var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownload = function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "download_svg__svg-icon",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m29.011 33.921-8.632-8.631-4.27 4.27L32 45.45l15.89-15.89-4.269-4.27-8.632 8.631V6.807h-5.978zM6.075 57.925h51.85V43.468h-6.039v8.418H12.114v-8.418H6.075z",
    clipRule: "evenodd"
  })));
};
export { SvgDownload as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNjQgNjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTI5LjAxMSAzMy45MjExTDIwLjM3OSAyNS4yODk3TDE2LjEwOTkgMjkuNTYwMkwzMiA0NS40NTAzTDQ3Ljg5MDEgMjkuNTYwMkw0My42MjEgMjUuMjg5N0wzNC45ODkgMzMuOTIxMVY2LjgwNjg4SDI5LjAxMVYzMy45MjExWk02LjA3NTAxIDU3LjkyNDlINTcuOTI1VjQzLjQ2NzlINTEuODg2VjUxLjg4NTlIMTIuMTE0VjQzLjQ2NzlINi4wNzUwMVY1Ny45MjQ5WiIgZmlsbD0iY3VycmVudENvbG9yIi8+PC9zdmc+";